import { Directive, Input, HostBinding } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[default]',
    // tslint:disable-next-line:no-host-metadata-property
    host: {
        '(error)': 'updateUrl()',
        '(load)': 'load()',
        '[src]': 'src'
    }
})

export class ImagePreloadDirective {
    @Input() src: string;
    @Input() default: { size: string, text?: string } | any;
    @HostBinding('class.image-loading') imgLoading = true;

    updateUrl() {
        // this.src = this.default;
        if (typeof this.default === 'string') {
            this.src = this.default;
        } else {
            const text = this.default.text ? this.default.text.replace(' ', '+') : null;
            this.src = `https://dummyimage.com/${this.default.size}/ddd/969696${text ? '?text=' + text : ''}`;
        }
    }
    load() {
        this.imgLoading = false;
    }
}
